import { useEffect, useState } from 'react';

const NAV_ITEMS = [
  { id: 'home', label: '首页' },
  { id: 'hot', label: '热门直达' },
  { id: 'categories', label: '主题分类' },
  { id: 'featured', label: '精选推荐' },
  { id: 'guide', label: '找瓜指南' },
  { id: 'faq', label: '常见问题' },
  { id: 'about', label: '关于本站' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
      let current = 'home';
      NAV_ITEMS.forEach((item) => {
        const el = document.getElementById(item.id);
        if (el && el.getBoundingClientRect().top <= 150) {
          current = item.id;
        }
      });
      setActive(current);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:h-20 md:px-6">
        <a href="#home" className="flex items-center gap-2.5" aria-label="黑料导航首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md text-lg md:h-10 md:w-10 ${
              solid ? 'bg-primary-500 text-background-50' : 'bg-background-50/95 text-primary-600'
            }`}
          >
            <i className="ri-emotion-laugh-line" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <strong
              className={`font-heading text-base font-bold md:text-lg ${
                solid ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              黑料导航
            </strong>
            <span
              className={`mt-0.5 text-[10px] tracking-wider md:text-xs ${
                solid ? 'text-foreground-500' : 'text-background-100/80'
              }`}
            >
              找瓜不迷路
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="站内导航">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                active === item.id
                  ? solid
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-background-50/20 text-background-50'
                  : solid
                    ? 'text-foreground-600 hover:bg-background-100 hover:text-foreground-950'
                    : 'text-background-100/90 hover:text-background-50'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            提交入口
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
            className={`flex h-10 w-10 items-center justify-center rounded-md text-xl transition-colors lg:hidden ${
              solid ? 'text-foreground-950 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/20'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden">
          <nav className="mx-auto grid w-full grid-cols-2 gap-2 border-t border-background-200 bg-background-50 px-4 py-4 md:grid-cols-3 md:px-6">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className={`flex items-center justify-between rounded-md border px-3 py-2.5 text-sm transition-colors ${
                  active === item.id
                    ? 'border-primary-200 bg-primary-100 text-primary-700'
                    : 'border-background-200 text-foreground-700 hover:border-primary-200 hover:text-foreground-950'
                }`}
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-base" aria-hidden="true"></i>
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setMenuOpen(false)}
              className="col-span-2 mt-1 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 md:col-span-3"
            >
              <i className="ri-add-circle-line" aria-hidden="true"></i>
              提交入口
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}